import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { getToken } from "../utils/token";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { userLogout } from "../Redux/AuthReducer/actionType";

export const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const {pathname} = useLocation();
  const token = getToken();
  const isAuthenticated = useIsAuthenticated();
  const isAuthRedux = useSelector((store) => store.AuthReducer.token);
  // Check if the token is expired

  const handleLogOut = async () => {
    try {
      // Parse isMicrosoftLogin as boolean properly
      const isMicrosoftLoginValue = localStorage.getItem("isMicrosoftLogin");
      const isMicrosoftUser = isMicrosoftLoginValue === "true";

      // Only call Microsoft logout if it's a Microsoft login
      if (isMicrosoftUser) {
        await instance.logoutPopup();
        // await instance.logoutRedirect();
      }

      // Clear local storage
      localStorage.setItem("Auth", JSON.stringify(""));
      localStorage.setItem("allowedRouters", JSON.stringify({}));
      localStorage.setItem("allowedPermissions", JSON.stringify({}));
      localStorage.setItem("userId", JSON.stringify(""));
      localStorage.setItem("makerCheckerPermission", JSON.stringify({}));
      localStorage.setItem("isMicrosoftLogin", JSON.stringify("false"));

      // Dispatch logout action
      dispatch({ type: userLogout });

      // Navigate to login page
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      // Still clear local storage and redirect even if Microsoft logout fails
      localStorage.setItem("Auth", "");
      localStorage.setItem("userId", "");
      dispatch({ type: userLogout });
      navigate("/login");
    }
  };

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded.exp < Date.now() / 1000) {
          handleLogOut();
        }
      } catch (error) {
        console.error("Invalid token", error);
        handleLogOut();
      }
    } else {
      handleLogOut();
    }
  }, [token,pathname]);

  const isAuth = isAuthenticated || isAuthRedux;

  if (!isAuth) {
    return <Navigate to="/login" />;
  }

  return children;
};
